module.exports = __webpack_public_path__ + "1b7837bd28fda1deb68b1c27fb4b8c01.png";